/**
 * DOMI-CARE - Barra de Navegación Superior y Conmutador de Rol / Conexión
 */

import { authState } from '../state/authState.js';
import { licenseState } from '../state/licenseState.js';
import { appsScriptClient } from '../api/appsScriptClient.js';
import { offlineStore } from '../api/offlineStore.js';
import { SuperAdminManager } from './superAdminModal.js';
import { notify } from './notificationCenter.js';

export function initTopBar(topbarElement, pacientes, activePatientId, onSelectPatient, onUserChange) {
  const user = authState.getActiveUser();
  const allUsers = authState.getAllUsers();
  const isOnline = navigator.onLine;
  const isLic = licenseState.isLicensed();

  topbarElement.innerHTML = `
    <div class="topbar-left">
      <!-- Selector de Paciente Activo -->
      <div class="patient-selector-container">
        <span style="font-size: 1rem;">👤</span>
        <select id="topbar-select-paciente" class="patient-selector-select" title="Seleccionar paciente activo">
          ${pacientes.map(p => `
            <option value="${p.id}" ${p.id === activePatientId ? 'selected' : ''}>
              ${p.nombreCompleto} (${p.obraSocial} - ${p.nivelComplejidad})
            </option>
          `).join('')}
        </select>
      </div>
    </div>

    <div class="topbar-right">
      <!-- Indicador de Red y Estado de Conexión (Protegido por PIN SuperAdmin) -->
      <div id="btn-open-connection" class="network-pill ${isOnline ? 'online' : 'offline'}" title="Estado de la plataforma">
        <span class="pulse-dot"></span>
        <span id="network-status-text">${isOnline ? (isLic ? 'Licencia Oficial Activa' : 'Modo Demo / Local') : 'Modo Offline (En Campo)'}</span>
      </div>

      <!-- Botón de Sincronización Manual y Cola de Registros -->
      <button id="btn-sync-now" class="btn btn-secondary btn-sm sync-badge-btn" title="Sincronizar cola de datos con Google Sheets">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67"/></svg>
        <span class="sync-count" id="sync-queue-count" style="display: none;">0</span>
      </button>

      <!-- Selector de Rol RBAC Activo (Simulador de Perfil) -->
      <div style="display: flex; align-items: center; gap: 0.5rem; background: var(--slate-100); padding: 0.3rem 0.65rem; border-radius: var(--radius-md); border: 1px solid var(--border-medium);">
        <span style="font-size: 0.75rem; color: var(--text-muted); font-weight: 700;">ROL:</span>
        <select id="topbar-select-user" style="border: none; background: transparent; font-weight: 700; font-size: 0.8rem; outline: none; cursor: pointer; color: var(--primary-800);">
          ${allUsers.map(u => `
            <option value="${u.id}" ${u.id === user.id ? 'selected' : ''}>
              ${u.rol} (${u.nombre.split(' ')[0]})
            </option>
          `).join('')}
        </select>
      </div>
    </div>
  `;

  // Listener para cambio de paciente
  const selectPac = document.getElementById('topbar-select-paciente');
  if (selectPac) {
    selectPac.addEventListener('change', (e) => {
      onSelectPatient(e.target.value);
    });
  }

  // Listener para cambio de usuario / rol
  const selectUser = document.getElementById('topbar-select-user');
  if (selectUser) {
    selectUser.addEventListener('change', async (e) => {
      await authState.switchUser(e.target.value);
      notify.info(`Perfil cambiado a: ${authState.getActiveUser().nombre} (${authState.getRole()})`);
      onUserChange();
    });
  }

  // Clic en la píldora de red: Abre el prompt de PIN para configuración SuperAdmin
  const pillBtn = document.getElementById('btn-open-connection');
  if (pillBtn) {
    pillBtn.addEventListener('click', () => {
      SuperAdminManager.openPinPrompt();
    });
  }

  // Sincronizar Ahora
  const syncBtn = document.getElementById('btn-sync-now');
  if (syncBtn) {
    syncBtn.addEventListener('click', async () => {
      notify.info('Iniciando sincronización con Google Sheets...');
      await appsScriptClient.syncPendingQueue();
      updateQueueBadge();
    });
  }

  // Escuchadores de eventos de cola y conectividad
  window.addEventListener('domicare:queue-updated', () => updateQueueBadge());
  window.addEventListener('domicare:sync-completed', (e) => {
    notify.success(`Sincronización completada: ${e.detail.count} registros enviados a Google Sheets.`);
    updateQueueBadge();
  });
  window.addEventListener('online', () => updateTopBarStatus());
  window.addEventListener('offline', () => updateTopBarStatus());
  window.addEventListener('domicare:license-updated', () => updateTopBarStatus());

  updateQueueBadge();
}

async function updateQueueBadge() {
  const pending = await offlineStore.getPendingQueue();
  const badge = document.getElementById('sync-queue-count');
  if (badge) {
    if (pending.length > 0) {
      badge.textContent = pending.length;
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }
  }
}

function updateTopBarStatus() {
  const statusTxt = document.getElementById('network-status-text');
  const pill = document.getElementById('btn-open-connection');
  const isOnline = navigator.onLine;
  const isLic = licenseState.isLicensed();

  if (pill && statusTxt) {
    if (!isOnline) {
      pill.className = 'network-pill offline';
      statusTxt.textContent = 'Modo Offline (En Campo)';
    } else if (isLic) {
      pill.className = 'network-pill online';
      statusTxt.textContent = 'Licencia Oficial Activa';
    } else {
      pill.className = 'network-pill online';
      statusTxt.textContent = 'Modo Demo / Local';
    }
  }
}
